import React, { Component } from 'react';
//import logo from './logo.svg';
//import '../App.css';
import firebase from '../components/Firestore'
import config from 'react-global-configuration';


// Components
import MarcoItem from '../components/Global/MarcoItem';
import { Offline, Online } from "react-detect-offline";


class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      uid: null
    };


  }

componentWillMount(){
  document.title = config.get('tienda').nombre
  firebase.auth().signInAnonymously().catch(function(error) {
    // Handle Errors here.
    //var errorCode = error.code;
    //var errorMessage = error.message;
    // ...
  });

  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      // User is signed in.
      //var isAnonymous = user.isAnonymous;
      var uid = user.uid;

      this.setState({uid: uid})
      // ...
    } else {
      // User is signed out.
      // ...
    }
  }
)

}



  render() {

    return (
      <div className="mx-md-5">

          <Online><MarcoItem uid={this.state.uid}/></Online>
          <Offline>
            <div>
              <div className="d-flex justify-content-center">
                <div>
                  <h3>Sin conexion a Internet</h3>
                  <p> Esta App necesita conexion a Internet.</p>
                </div>
              </div>

            </div>

            </Offline>

      </div>
    )
  }
}

export default App;
